// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__88hOB","buttons":"PendingPaymentAlert_buttons__2it0a"};